<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card v-if="onBoarded" class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                </v-toolbar>
            </v-card>
            <div v-if="!onBoarded" :class="isMobile?'welcome-mobile':'welcome'">
                <h3 class="primary--text">Welcome to SweldoNow! We're thrilled to have you on board. </h3><br>
                <p>{{welcome_message}}</p>
                <div>If you are an <b>admin</b>, your first step should be to complete the <a href="javascript:window.open('https://help.sweldonow.ph/guide/new-company-setup.html')"><b>New Company Setup</b></a> to configure your company's payroll settings and start using the system effectively.
                    For a detailed walkthrough, visit the <a href="javascript:window.open('https://help.sweldonow.ph/guide')"><b>User Guide</b></a>, where you'll find everything you need to get started and make the most of SweldoNow.
                    Explore the platform and let us simplify your payroll management today!<br><br>
                    Also, check out our <a href="javascript:window.open('https://help.sweldonow.ph/demo')"><b>Product Demo Videos</b></a> for an in-depth look at how our system works. These demos cover various features, including payroll processing, attendance management, and more—giving you a comprehensive understanding of how SweldoNow can streamline your payroll operations.
                </div>
            </div>
            <v-layout row wrap :style="isMobile?'padding-top:5px':'padding:5px'">
                <v-flex xs12 sm4 v-for="(item,index) in quick_links" :key="index">
                    <v-hover>
                        <v-card slot-scope="{hover}" :class="`elevation-${hover?3:1}`" @click="viewPage(item)" style="cursor:pointer;height:120px;overflow:hidden;">
                            <v-toolbar flat height="35">
                                <span class="body-2">
                                    {{item.pageName}}
                                </span>
                                <v-spacer></v-spacer>
                                <!-- <v-icon small color="primary" title="Add to favorites">favorite</v-icon> -->
                            </v-toolbar>
                            <v-card-text xs12 class="caption">
                                <v-layout row wrap>
                                    <v-flex xs2>
                                        <v-icon size="35" class="mr-1" :color="hover?'primary':''" :style="isMobile?'margin-left:15px;':'margin-left:5px;'">{{item.pageIcon}}</v-icon>
                                    </v-flex>
                                    <v-flex xs10>
                                        <div class="menu-description">
                                            {{item.pageDescription}}
                                        </div>
                                    </v-flex>
                                </v-layout>
                            </v-card-text>
                        </v-card>
                    </v-hover>
                </v-flex>
            </v-layout>
        </v-flex>
    </v-layout>
</template>

<script>

import userApi from '@/api/user'

export default {
    name: 'AppFeatures',
    metaInfo: {
        title: 'App Features',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'App Features' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {},
    data () {
      return {
        error: false,
        errorMessage: '',
        welcome_message: "With our user-friendly platform, managing your payroll tasks has never been easier. To get started, explore the following links to learn and familiarize yourself with the app.",
        quick_links: [
            {
                pagePath: "https://help.sweldonow.ph/guide/new-company-setup.html",
                externalLink: true,
                pageName: "New Company Setup",
                pageIcon: "info",
                pageDescription: "Your starting point for configuring your organization in SweldoNow. It provides instructions for setting up the your company's structure, schedules, and policies."
            },
            {
                pagePath: "https://help.sweldonow.ph/demo/",
                externalLink: true,
                pageName: "Product Demo",
                pageIcon: "fab fa-youtube",
                pageDescription: "Videos designed to provide a comprehensive and in-depth look at how SweldoNow works."
            },
            {
                pagePath: "https://help.sweldonow.ph/guide",
                externalLink: true,
                pageName: "User Guide",
                pageIcon: "help",
                pageDescription: "A comprehensive resource designed to guide users through every aspect of managing payroll with SweldoNow."
            },
            {
                pagePath: "/mysettings",
                externalLink: false,
                pageName: "My Settings",
                pageIcon: "settings",
                pageDescription: "Customize themes, enable 2-factor authentication, and manage your password."
            },
            {
                pagePath: "/notifications",
                externalLink: false,
                pageName: "Notifications",
                pageIcon: "notifications",
                pageDescription: "Stay updated with workflow alerts. Get real-time notifications for payroll activities."
            },
            {
                pagePath: "/myprofile",
                externalLink: false,
                pageName: "My Profile",
                pageIcon: "account_box",
                pageDescription: "Personalize your profile. Update your avatar, view personal, employment, team assignment, and bank details."
            },
            {
                pagePath: "/features",
                externalLink: false,
                pageName: "Features",
                pageIcon: "featured_play_list",
                pageDescription: "Stay informed about latest enhancements. Discover quick fixes, monthly releases, and tools for efficient payroll management."
            }
        ],
        //future updates - pull data from db. populate on every monthly or quick fix releases
        features: []
      }
    },
    methods: {
        viewPage(data) {
            if (data.externalLink) {
                window.open(data.pagePath)
            }else{
                this.$router.push(data.pagePath)
            }
        },
        async updateOnbarded() {
            try {
                await userApi.onBoarded()
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        }
    },
    async created() {
        this.$root.$emit('setHeaderTitles', {
            display: true,
            isMainMenu: true,
            headerTitle: 'App',
            headerPageTitle: 'Features'
        })
        if (!this.onBoarded) this.updateOnbarded()
    },
    computed: {
        isMobile() {
            return window.innerWidth < 600
        },
        onBoarded() {
            return this.$store.state.onBoarded
        }
    }
}
</script>
<style scoped>
.welcome {
    border-radius:5px;
    margin:45px 5px 0px 5px;
    padding:20px;
    border:1px solid #1976D2;
}
.welcome-mobile {
    border-radius:5px;
    margin:47px 0px 0px 0px;
    padding:20px;
    border:1px solid #1976D2;
}
</style>